export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14247.18b42a2b.jpg";